import React from 'react';
import './style.scss';

export const Separator = () => {
  return (
    <div className="separator">
      <span />
      <span>or</span>
      <span />
    </div>
  );
};

export const WhiteBorder = () => {
  return <div className="whiteBorder"></div>;
};

export const GrayBorder = () => {
  return <div className="grayBorder"></div>;
};
